"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const type_graphql_1 = require("type-graphql");
const typeorm_1 = require("typeorm");
const OsmosysBaseEntity_1 = require("../OsmosysBaseEntity");
const Context_1 = require("../core/Context");
const emails_1 = require("../emails");
const auth_1 = require("../auth");
const Workspace_1 = require("../auth/Workspace");
const ContentConversionStep_1 = require("../converter/ContentConversionStep");
let Ad = class Ad extends OsmosysBaseEntity_1.OsmosysBaseEntity {
};
tslib_1.__decorate([
    type_graphql_1.Field(() => auth_1.User),
    typeorm_1.ManyToOne(() => auth_1.User, {
        cascade: true,
        nullable: true,
        onDelete: 'SET NULL',
    }),
    tslib_1.__metadata("design:type", Object)
], Ad.prototype, "creatingUser", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column(),
    tslib_1.__metadata("design:type", String)
], Ad.prototype, "name", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column({ default: '' }),
    tslib_1.__metadata("design:type", String)
], Ad.prototype, "html", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Workspace_1.Workspace),
    typeorm_1.ManyToOne(() => Workspace_1.Workspace),
    typeorm_1.JoinColumn(),
    tslib_1.__metadata("design:type", Object)
], Ad.prototype, "workspace", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => [emails_1.EmailTemplateBlock]),
    typeorm_1.OneToMany(() => emails_1.EmailTemplateBlock, block => block.ad),
    tslib_1.__metadata("design:type", Object)
], Ad.prototype, "blocksUsedIn", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => [ContentConversionStep_1.ContentConversionStep]),
    typeorm_1.OneToMany(() => ContentConversionStep_1.ContentConversionStep, contentConversionStep => contentConversionStep.ad),
    tslib_1.__metadata("design:type", Object)
], Ad.prototype, "conversionStepsUsedIn", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => [Context_1.Context]),
    typeorm_1.ManyToMany(() => Context_1.Context, context => context.adsAvailableForUseIn),
    typeorm_1.JoinTable(),
    tslib_1.__metadata("design:type", Object)
], Ad.prototype, "availableContexts", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Context_1.Context, { nullable: true }),
    typeorm_1.ManyToOne(() => Context_1.Context, context => context.adsAvailableForUseIn),
    tslib_1.__metadata("design:type", Object)
], Ad.prototype, "defaultContext", void 0);
Ad = tslib_1.__decorate([
    type_graphql_1.ObjectType(),
    typeorm_1.Entity()
], Ad);
exports.Ad = Ad;
class AdEntity extends Ad {
    toEndpoint() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return '/ads';
        });
    }
    toString() {
        return this.name;
    }
}
exports.AdEntity = AdEntity;
//# sourceMappingURL=Ad.js.map